import * as React from 'react'

import * as plume from '@ulule/owl-kit-components/next'

import * as money from '@owl-nest/money'
import * as env from '@owl-nest/config'

import { type InputProps } from './types'

type TipInputProps = InputProps & {
  error: boolean
}

export function TipInput({
  symbol,
  error,
  onChange,
  selected,
  translations,
  value,
}: TipInputProps): React.ReactElement<TipInputProps> {
  const userConfig = env.useUserEnv()

  return (
    <plume.MoneyField
      data-testid="component:tip.input"
      symbol={symbol}
      error={error}
      symbolPosition={money.getPosition(userConfig.lang)}
      selected={selected}
      onChange={(event) => {
        onChange?.(event.target.value)
      }}
      placeholder={translations?.placeholder}
      value={value}
      min="1"
    />
  )
}
